"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaStoryContentContainerWrapperProperty = exports.ctaStoryContentContainerWrapperPropertyDefinition = void 0;
exports.ctaStoryContentContainerWrapperPropertyDefinition = {
    view: { label: 'CTA' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['cta-story-content-container'],
        },
    ],
    type: 'ordered-container',
    multiple: false,
    name: 'cta-story-content-container-wrapper',
};
const isCtaStoryContentContainerWrapperProperty = (prop) => {
    return prop.name === exports.ctaStoryContentContainerWrapperPropertyDefinition.name;
};
exports.isCtaStoryContentContainerWrapperProperty = isCtaStoryContentContainerWrapperProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLXN0b3J5LWNvbnRlbnQtY29udGFpbmVyLXdyYXBwZXIucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9jdGEtc3RvcnktY29udGVudC1jb250YWluZXItd3JhcHBlci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlEQUFpRCxHQUFHO0lBQy9ELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUU7SUFDdEIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRSxDQUFDLDZCQUE2QixDQUFDO1NBQzFDO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHFDQUFxQztDQUNaLENBQUE7QUFJMUIsTUFBTSx5Q0FBeUMsR0FBRyxDQUFDLElBQWtCLEVBQW1ELEVBQUU7SUFDL0gsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHlEQUFpRCxDQUFDLElBQUksQ0FBQTtBQUM3RSxDQUFDLENBQUE7QUFGWSxRQUFBLHlDQUF5Qyw2Q0FFckQifQ==